'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Listbox", {
    enumerable: true,
    get: function() {
        return Listbox;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useListbox = require("./useListbox");
const _renderListbox = require("./renderListbox");
const _useListboxStylesstyles = require("./useListboxStyles.styles");
const _useListboxContextValues = require("../../contexts/useListboxContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Listbox = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useListbox.useListbox_unstable)(props, ref);
    const contextValues = (0, _useListboxContextValues.useListboxContextValues)(state);
    (0, _useListboxStylesstyles.useListboxStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useListboxStyles_unstable')(state);
    return (0, _renderListbox.renderListbox_unstable)(state, contextValues);
});
Listbox.displayName = 'Listbox';
